import React from 'react'
import './educations.css'
import { FaGraduationCap, FaCertificate } from 'react-icons/fa'
import dogus from "../../assets/dogus.jpeg";
import GCD from "../../assets/GCD.jpeg";
import { educations, certifications } from '../../data/profile';

const LOGOS = { gcd: GCD, dogus };

const Educations = () => {
  return (
    <section id="educations">
      <h5>Degrees That I Have</h5>
      <h2>Education</h2>

      <div className="container educations__container">
        {educations.map(({ degree, school, location, period, logo, note }) => (
          <article className="education" key={degree}>
            <div className="education__logo">
              {LOGOS[logo]
                ? <img src={LOGOS[logo]} alt={school} />
                : <FaGraduationCap aria-hidden="true" />}
            </div>
            <span className="education__period">{period}</span>
            <h3>{degree}</h3>
            <p className="education__school">{school}</p>
            <p className="education__location">{location}</p>
            {note && <p className="education__note">{note}</p>}
          </article>
        ))}
      </div>

      <div className="container certifications">
        <h3 className="certifications__title">Certifications</h3>
        <div className="certifications__grid">
          {certifications.map(({ title, issuer }) => (
            <article className="certification" key={title}>
              <span className="certification__icon"><FaCertificate aria-hidden="true" /></span>
              <div>
                <h4>{title}</h4>
                {issuer && <p>{issuer}</p>}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Educations
